/**
 * useRegisterToken hook
 *
 * TanStack Query mutation for registering token metadata after on-chain deployment.
 * Story 2.4 - Task 6.1
 */

import type { RegisterTokenRequest, TokenResponse } from "@repo/shared-types";
import { type UseMutationResult, useMutation } from "@tanstack/react-query";

import { tokensApi } from "../../lib/api";

type RegisterTokenInput = {
	request: RegisterTokenRequest;
	token: string;
	walletAddress?: string;
};

export function useRegisterToken(): UseMutationResult<TokenResponse, Error, RegisterTokenInput> {
	return useMutation({
		mutationFn: ({ request, token, walletAddress }: RegisterTokenInput) =>
			tokensApi.register(request, token, walletAddress).then((res) => res.data),
	});
}
